import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import { NavLink } from "react-router-dom";
//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
    // Select,
    Input,
	InputLabel,
	// MenuItem,
	Modal,
	Backdrop,
    Fade,
    Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
//cookies
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";
const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	// paper: {
	// 	backgroundColor: theme.palette.background.paper,
	// 	border: "2px solid #000",
	// 	boxShadow: theme.shadows[5],
	// 	padding: theme.spacing(2, 4, 3),
	// },
}));

const InventoryAdjustmentHistory = () => {
    const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: new Date(),
	});
	const classes = useStyles();
    const [branchidNo, setbranchidNo] = useState(get_cookies('branchidno'));
	const [downloadFlag, setDownloadFlag] = useState(false);
	
	// Data Fetching
	useEffect(() => {
		data();
		dataFilter();
	}, []);
	
	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);

	const { REACT_APP_API_URL } = process.env;

	//search button
	const dataFilter = async () => {
		setDataLoaded(false);	
        await axios.get(
				`${process.env.REACT_APP_API_URL}/get_inv_adj_history_table`, {
            params:{
                date_from: format(dateRange.startDate, "yyyy-MM-dd"), //format(dateRange.startDate, "yyyy/MM/dd/")
                date_to: format(dateRange.endDate, "yyyy-MM-dd"),   //format(dateRange.endDate, "yyyy/MM/dd/")
                jc_user_id_no: branchidNo,  //branchidNo
            }
        }).then((res=>{
			setPosts(res.data.data);
			setDataLoaded(true);
		})).catch((error=>{
			console.log(error.message)
		}))		
    }
    
    const data = async () => {
		setDataLoaded(true);	
    };

    const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
    };
    
    const columns = [
            {
                name: "trandate",
                label: "Transaction Date",
                options: {
					sort:true,
                    // display: "excluded",
                },
            },
            {
                name: "adjno",
                label: "Adjustment No.",
                options: {
					sort:true,
                    // display: "excluded",
                },
            },
            {
                name: "adjtype",
                label: "Type",
                options: {
					sort:true,
                    // display: "excluded",
                },
            },
            {
                name: "adjno",
                label:"Actions",
                options: {
					sort:false, 
					filter: false, 
                    customBodyRenderLite: (dataIndex) => {
                        let id = posts[dataIndex].adjno;
                            return (
                                <Grid container spacing={1}>
                                    <Grid item xs={6} lg={4} xl={3}>
										<NavLink to={"/inventory/inventory-adjustment-history-edit/"+id+"/"+branchidNo}>
                                            <Button variant="contained" color="primary" style={{backgroundColor: "#4caf50", color:"#fff"}}>
                                                Edit
                                            </Button>	
                                           </NavLink> 
                                    </Grid>
                                    <Grid item xs={6} lg={4} xl={3}>
                                        <NavLink to={"/inventory/inventory-adjustment-history-view/"+id+"/"+branchidNo}>
                                            <Button variant="contained" color="primary">
                                                View
                                            </Button>	
                                        </NavLink> 
                                    </Grid>
                                </Grid>
                            );
                    },download:false //exlclude this column in excel csv
                }
            }
        ];
 
        const options = {
            filter: true,
            filterType: "dropdown",
            selectableRows: "none",
            //filterType: "multiselect",
            responsive: "standard",
            setFilterChipProps: (colIndex, colName, data) => {
                console.log(colIndex, colName, data);
                return {
                    color: "primary",
                    variant: "outlined",
                    className: "testClass123",
                };
            },
			download: downloadFlag,  //add this
			print: downloadFlag, //add this
			downloadOptions: {
                filename : 'InventoryAdjustmentHistory.csv' //change filename of csv
            }
            // tableBodyHeight,
		};
		
		const style = {
            marginBottom: '1rem',
        };

        return (
            		<div className="page">
            			<div className="page-header">
            				<div className="page-icon">
            					<AssessmentTwoTone />
            				</div>
            				<NavLink to={"/inventory"}><h4 style={{color:"#339933"}}>Inventory</h4></NavLink>
							<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
            				<h4 className="header-title">Inventory Adjustment History</h4>
            			</div>
            			<div className="page-container">
							<div style={style}>
                            <Grid container spacing={1}>
                           	 	<Grid item xs={12} sm={4} md={4} lg={3} xl={3}>
            							<TextField
											id="outlined-basic"
											label="Select Date"
											variant="outlined"
											onFocus={() => setOpen(true)}
											fullWidth={true}
											autoComplete="off"
											value={`${format(
												dateRange.startDate,
												"MM/dd/yyyy"
											)} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
										/>
										<DateRangePicker
											open={open}
											toggle={toggle}
											onChange={(range) => dateRangeHandler(range)}
										/> 
									</Grid>
                                    <Grid item xs={1} lg={1} xl={1}>
							            <Button style ={{marginTop: "22px"}} variant="contained" color="primary"  onClick={() => {dataFilter()}}>Search</Button>
						            </Grid>
								</Grid>	
							</div>
								
            				{!dataLoaded ? (
            					<Preloader />
            				) : (
            					<MUIDataTable
            						title={
            							<div>
            						
            								<div className="table-title">
                                            Inventory Adjustment History
            								</div>
            							</div>
            						}
            						data={posts}
            						columns={columns}
            						options={options}
            					/>
            				)}
            			</div>
            		</div>
            	);
};
 
export default InventoryAdjustmentHistory; 